import api from "./api";

const route = "/payment_sources";

const MetodosService = {
  getMetodos: () => api.get(route),
  deleteMetodoPago: (payment_source_id) =>
    api.delete(`${route}/${payment_source_id}`),
  postMetodoPago: (token_id, card_type, last_digits, saveCard) =>
    api.post(route, { token_id, card_type, last_digits, saveCard }),
};

export default MetodosService;
